import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { autoOpen: Boolean };

  connect() {
    if (this.autoOpenValue) {
      this.open();
    }
  }

  open() {
    const dialog = this.element.querySelector("[data-native-dialog-target='dialog']");
    if (dialog) {
      dialog.showModal();
    }
  }
}
